import React, {Component} from 'react'
import PropTypes from 'prop-types'
import BasketItem from "./BasketItem"


class ListBasketItems extends Component {
    render() {
        const {items, type = ''} = this.props
        if (!items || !items.length) return null

        return (
            <div className="ListBasketItems">
                <table className="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Đơn</th>
                        {type === "combo_fac" && <th>FAC</th>}
                        <th>Tình trạng</th>
                        <th>In</th>
                        <th>Loại</th>
                        <th>Màu</th>
                        <th>Size</th>
                        <th>Quá hạn</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        items.map((item, index) => {
                            return (
                                <BasketItem index={index} item={item} key={item._id} type={type}/>
                            )
                        })
                    }
                    </tbody>
                </table>

            </div>
        )
    }
}

ListBasketItems.propTypes = {
    items: PropTypes.array.isRequired,
}

export default ListBasketItems
